import axios from 'axios';
import api from "../api";

async function getArrangements(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.string_sizer.get, params)
      .then(response => {
        resolve({
          arrangements: response.data,
        })
      })
      .catch(error => {
        reject(error);
      })
  });

}
async function generatePossibilities(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.string_sizer.generatePossibilities, params)
      .then(response => {
        resolve({
          arrangements: response.data,
        })
      })
      .catch(error => {
        reject(error);
      })
  });

}

async function getUniqueCombinations(params) {
  return new Promise((resolve, reject) => {
    axios.get(api.string_sizer.getUniqueCombinations, params)
      .then(response => {
        resolve({
          combinations: response.data,
        })
      })
      .catch(error => {
        reject(error);
      })
  });
}

async function generatePossibilitiesQueue(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.string_sizer.generatePossibilitiesQueue, params)
      .then(response => {
        resolve({
          queue: response.data,
        })
      })
      .catch(error => {
        reject(error);
      })
  });

}

export default {
  getArrangements,
  generatePossibilities,
  getUniqueCombinations,
  generatePossibilitiesQueue
};